import classNames from 'classnames';

import styles from './CheckBox.module.scss';

type CheckBoxProps = {
  name: string;
  value: string | number;
  onClick?: () => void;
  label: string | JSX.Element;
  checked: boolean;
  disabled?: boolean;
  className?: string;
};

const CheckBox = ({
  name,
  value,
  checked,
  onClick,
  label,
  disabled,
  className,
}: CheckBoxProps) => {
  return (
    <div
      className={classNames(styles.checkBoxWrapper, className ?? '')}
      onClick={() => onClick && onClick()}
    >
      <div className={styles.checkbox}>
        <input
          name={name}
          type="checkbox"
          disabled={disabled}
          value={value}
          checked={checked}
          readOnly
        />
        <span className={styles.checkmark} />
      </div>
      <span className={classNames(styles.label, 'label')}>{label}</span>
    </div>
  );
};

export default CheckBox;
